// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 1024px) {
  .col-sm-1 {
    width: 8.33%;
  }
  .col-sm-2 {
    width: 16.66%;
  }
  .col-sm-3 {
    width: 25%;
  }
  .col-sm-4 {
    width: 33.33%;
  }
  .col-sm-5 {
    width: 41.66%;
  }
  .col-sm-6 {
    width: 50%;
  }
  .col-sm-7 {
    width: 58.33%;
  }
  .col-sm-8 {
    width: 66.66%;
  }
  .col-sm-9 {
    width: 75%;
  }
  .col-sm-10 {
    width: 83.33%;
  }
  .col-sm-11 {
    width: 91.66%;
  }
  .col-sm-12 {
    width: 100%;
  }
  .col-sm-offset-1 {
    margin-left: 8.33%;
  }
  .col-sm-offset-2 {
    margin-left: 16.66%;
  }
  .col-sm-offset-3 {
    margin-left: 25%;
  }
  .col-sm-offset-4 {
    margin-left: 33.33%;
  }
  .col-sm-offset-5 {
    margin-left: 41.66%;
  }
  .col-sm-offset-6 {
    margin-left: 50%;
  }
  .col-sm-offset-7 {
    margin-left: 58.33%;
  }
  .col-sm-offset-8 {
    margin-left: 66.66%;
  }
  .col-sm-offset-9 {
    margin-left: 75%;
  }
  .col-sm-offset-10 {
    margin-left: 83.33%;
  }
  .col-sm-offset-11 {
    margin-left: 91.66%;
  }
  .col-sm-offset-12 {
    margin-left: 100%;
  }
}
@media (min-width: 1025px) {
  .col-md-1 {
    width: 8.33%;
  }
  .col-md-2 {
    width: 16.66%;
  }
  .col-md-3 {
    width: 25%;
  }
  .col-md-4 {
    width: 33.33%;
  }
  .col-md-5 {
    width: 41.66%;
  }
  .col-md-6 {
    width: 50%;
  }
  .col-md-7 {
    width: 58.33%;
  }
  .col-md-8 {
    width: 66.66%;
  }
  .col-md-9 {
    width: 75%;
  }
  .col-md-10 {
    width: 83.33%;
  }
  .col-md-11 {
    width: 91.66%;
  }
  .col-md-12 {
    width: 100%;
  }
  .col-md-offset-1 {
    margin-left: 8.33%;
  }
  .col-md-offset-2 {
    margin-left: 16.66%;
  }
  .col-md-offset-3 {
    margin-left: 25%;
  }
  .col-md-offset-4 {
    margin-left: 33.33%;
  }
  .col-md-offset-5 {
    margin-left: 41.66%;
  }
  .col-md-offset-6 {
    margin-left: 50%;
  }
  .col-md-offset-7 {
    margin-left: 58.33%;
  }
  .col-md-offset-8 {
    margin-left: 66.66%;
  }
  .col-md-offset-9 {
    margin-left: 75%;
  }
  .col-md-offset-10 {
    margin-left: 83.33%;
  }
  .col-md-offset-11 {
    margin-left: 91.66%;
  }
  .col-md-offset-12 {
    margin-left: 100%;
  }
}
.confirm-wrapper {
  margin: 0 16.66%;
}
.confirm-wrapper h1 {
  margin: 30px 0;
}
.confirm-wrapper .alert {
  margin-bottom: 30px;
  border-radius: 8px;
}
.confirm-wrapper .alert div:first-child {
  border-radius: 8px 0 0 8px;
}
@media only screen and (max-width: 700px) and (min-width: 390px) {
  .confirm-wrapper .alert .close {
    right: -6px;
    top: -2px;
  }
}
.confirm-wrapper .panel-header {
  background-color: hsl(0, 0%, 95%);
  border: 0;
  margin: 30px 0 0;
}
.confirm-wrapper .panel-header .panel-message {
  padding: 20px 10px 1px 30px;
}
.confirm-wrapper .buttons-section {
  margin-top: 30px;
  padding: 30px 0 60px;
}
.confirm-wrapper .buttons-section .btn-cancel {
  margin-right: 5px;
}
.confirm-wrapper .btn-link {
  padding-top: 10px;
}
@media (max-width: 1024px) {
  .confirm-wrapper .btn-link {
    padding-top: 0;
  }
  .confirm-wrapper .btn {
    padding: 0;
  }
  .confirm-wrapper .btn-cancel {
    margin: 20px 0 0;
  }
  .confirm-wrapper .buttons-section {
    padding: 30px 0;
  }
}
.confirm-wrapper app-customgrid div p {
  display: none;
}
.confirm-wrapper .home-link {
  margin-left: -17px;
  margin-top: -14px;
}
@media (max-width: 1024px) {
  .confirm-wrapper {
    margin: 0 15px;
    margin-top: 70px;
  }
  .confirm-wrapper .btn {
    text-align: center;
    width: 100%;
  }
}

.confirm-wrappermdm {
  margin: 0 16.66%;
}
.confirm-wrappermdm h1 {
  margin: 30px 0;
}
.confirm-wrappermdm .alert {
  margin-bottom: 30px;
}
.confirm-wrappermdm .panel-header {
  background-color: hsl(0, 0%, 95%);
  border: 0;
  margin: 30px 0 0;
}
.confirm-wrappermdm .panel-header .panel-message {
  padding: 20px 10px 1px 30px;
}
.confirm-wrappermdm .buttons-section {
  margin-top: 30px;
  padding: 30px 0 60px;
}
.confirm-wrappermdm .buttons-section .btn-cancel {
  margin-right: 5px;
}
.confirm-wrappermdm .btn-link {
  padding-top: 10px;
}
@media (max-width: 1024px) {
  .confirm-wrappermdm .btn-link {
    padding-top: 0;
  }
  .confirm-wrappermdm .btn {
    padding: 0;
  }
  .confirm-wrappermdm .btn-cancel {
    margin: 20px 0 0;
  }
  .confirm-wrappermdm .buttons-section {
    padding: 30px 0;
  }
}
.confirm-wrappermdm app-customgrid div p {
  display: none;
}
.confirm-wrappermdm .home-link {
  margin-left: -17px;
  margin-top: -14px;
}
@media (max-width: 1024px) {
  .confirm-wrappermdm {
    margin: 0 15px;
  }
  .confirm-wrappermdm .btn {
    text-align: center;
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/lib/ng2-sapmp/src/assets/style/mixinfunction.scss","webpack://./src/lib/ng2-sapmp/src/assets/style/variables.scss","webpack://./src/app/pages/cancel-participation/confirm-cancel/confirm-cancel.component.scss"],"names":[],"mappings":"AAwBI;EA4BA;IACE,YClDE;ECAN;EFiDE;IACE,aClDE;ECGN;EF8CE;IACE,UClDE;ECMN;EF2CE;IACE,aClDE;ECSN;EFwCE;IACE,aClDE;ECYN;EFqCE;IACE,UClDE;ECeN;EFkCE;IACE,aClDE;ECkBN;EF+BE;IACE,aClDE;ECqBN;EF4BE;IACE,UClDE;ECwBN;EFyBE;IACE,aClDE;EC2BN;EFsBE;IACE,aClDE;EC8BN;EFmBE;IACE,WClDE;ECiCN;EFqBE;IACE,kBCvDE;ECoCN;EFkBE;IACE,mBCvDE;ECuCN;EFeE;IACE,gBCvDE;EC0CN;EFYE;IACE,mBCvDE;EC6CN;EFSE;IACE,mBCvDE;ECgDN;EFME;IACE,gBCvDE;ECmDN;EFGE;IACE,mBCvDE;ECsDN;EFAE;IACE,mBCvDE;ECyDN;EFHE;IACE,gBCvDE;EC4DN;EFNE;IACE,mBCvDE;EC+DN;EFTE;IACE,mBCvDE;ECkEN;EFZE;IACE,iBCvDE;ECqEN;AACF;AF7CI;EAoCA;IACE,YC9DE;EC0EN;EFbE;IACE,aC9DE;EC6EN;EFhBE;IACE,UC9DE;ECgFN;EFnBE;IACE,aC9DE;ECmFN;EFtBE;IACE,aC9DE;ECsFN;EFzBE;IACE,UC9DE;ECyFN;EF5BE;IACE,aC9DE;EC4FN;EF/BE;IACE,aC9DE;EC+FN;EFlCE;IACE,UC9DE;ECkGN;EFrCE;IACE,aC9DE;ECqGN;EFxCE;IACE,aC9DE;ECwGN;EF3CE;IACE,WC9DE;EC2GN;EFzCE;IACE,kBCnEE;EC8GN;EF5CE;IACE,mBCnEE;ECiHN;EF/CE;IACE,gBCnEE;ECoHN;EFlDE;IACE,mBCnEE;ECuHN;EFrDE;IACE,mBCnEE;EC0HN;EFxDE;IACE,gBCnEE;EC6HN;EF3DE;IACE,mBCnEE;ECgIN;EF9DE;IACE,mBCnEE;ECmIN;EFjEE;IACE,gBCnEE;ECsIN;EFpEE;IACE,mBCnEE;ECyIN;EFvEE;IACE,mBCnEE;EC4IN;EF1EE;IACE,iBCnEE;EC+IN;AACF;AAjJA;EACE,gBAAA;AAmJF;AAhJE;EACE,cAAA;AAkJJ;AA9IE;EACE,mBAAA;EACA,kBAAA;AAgJJ;AA9IE;EACE,0BAAA;AAgJJ;AA9IE;EACC;IACC,WAAA;IACA,SAAA;EAgJF;AACF;AA9IE;EACE,iCAAA;EACA,SAAA;EACA,gBAAA;AAgJJ;AA9II;EACE,2BAAA;AAgJN;AA3IE;EAEE,gBAAA;EACA,oBAAA;AA4IJ;AAzII;EACE,iBAAA;AA2IN;AAvIE;EACE,iBAAA;AAyIJ;AFhKI;EE2BA;IACE,cAAA;EAwIJ;EArIE;IACE,UAAA;EAuIJ;EAnIE;IACE,gBAAA;EAqIJ;EAlIE;IACE,eAAA;EAoIJ;AACF;AA/HM;EACE,aAAA;AAiIR;AA5HE;EACE,kBAAA;EACA,iBAAA;AA8HJ;AFrLI;EEtBJ;IAiFI,cAAA;IACA,gBAAA;EA8HF;EA5HE;IACE,kBAAA;IACA,WAAA;EA8HJ;AACF;;AAxHA;EACE,gBAAA;AA2HF;AAzHE;EACE,cAAA;AA2HJ;AAxHE;EACE,mBAAA;AA0HJ;AAvHE;EACE,iCAAA;EACA,SAAA;EACA,gBAAA;AAyHJ;AAvHI;EACE,2BAAA;AAyHN;AArHE;EAEE,gBAAA;EACA,oBAAA;AAsHJ;AApHI;EACE,iBAAA;AAsHN;AAlHE;EACE,iBAAA;AAoHJ;AF3NI;EE2GA;IACE,cAAA;EAmHJ;EAhHE;IACE,UAAA;EAkHJ;EA/GE;IACE,gBAAA;EAiHJ;EA9GE;IACE,eAAA;EAgHJ;AACF;AA3GM;EACE,aAAA;AA6GR;AAxGE;EACE,kBAAA;EACA,iBAAA;AA0GJ;AFhPI;EEuEJ;IAmEI,cAAA;EA0GF;EAxGE;IACE,kBAAA;IACA,WAAA;EA0GJ;AACF","sourcesContent":["@import 'variables';\n\n@function color($color-name, $color-variant: null) {\n  // color variant is optional\n  @if ($color-variant != null) {\n    // map inception\n    @return map-get(map-get($colors, $color-name), $color-variant);\n  }@else {\n    @return map-get($colors, $color-name);\n  }\n}\n// buttons building section\n\n$btns: (\n  default: color(default, base),\n  primary: color(primary, base),\n  secondary:  color(secondary, base),\n  inverse: color(inverse, light),\n  success: color(success, base),\n  danger:  color(danger, base)\n);\n\n@mixin respond-to($breakpoint) {\n  @if $breakpoint == 'small' {\n    @media (max-width: 1024px) {\n      @content;\n    }\n  }@else if $breakpoint == 'large' {\n    @media (min-width: 1025px) {\n      @content;\n    }\n  }\n}\n\n@mixin vendor-prefix($name, $value) {\n  @each $vendor in ('-webkit-', '-moz-', '-ms-', '-o-', '') {\n    #{$name}: #{$value};\n  }\n}\n\n\n@mixin placeholder() {\n  color: color(inverse, light) !important;\n  font-family: 'Omnes-ATT-W02-Italic'!important;\n  font-style: normal;\n  opacity: 1;\n  font-size: 16px;\n}\n\n// dynamic\n@include respond-to(small) {\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n@include respond-to (large) {\n  @each $gridname, $gridvalue in $grids {\n    .col-md-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-md-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n","// Global Variables\n@import './../../../../../assets/style/var-config';\n// grids here\n$grids: (\n  1: 8.33%,\n  2: 16.66%,\n  3: 25%,\n  4: 33.33%,\n  5: 41.66%,\n  6: 50%,\n  7: 58.33%,\n  8: 66.66%,\n  9: 75%,\n  10: 83.33%,\n  11: 91.66%,\n  12: 100%\n);\n\n\n// refer http://digitaldesign.web.att.com/getstarted-color.html\n$att-dark-blue: hsl(205, 94%, 35%); // #0568ae\n$f-red: hsl(0, 66%, 49%); // #cf2a2a Functional Red\n$fb-gray: hsl(0, 0%, 95%); // #f2f2f2 Functional background Gray\n$att-dark-gray: hsl(0, 0%, 35%); // #5a5a5a\n$f-green: hsl(150, 100%, 24%); // #007a3e functional Green\n// $att-orange: hsl(30, 100%, 46%); // #ea7400 ATT Orange\n$att-orange: #ea7400; //ATT Orange\n\n// set color map easy use variables\n$primary: $att-orange !default;\n$secondary: $att-dark-blue !default;\n$default: $fb-gray !default;\n$inverse: $att-dark-gray !default;\n$danger: $f-red !default;\n$success: $f-green !default;\n\n\n// color variable map\n$colors: (\n  info: #009fdb,\n  enrolledActive:  #66cc00,\n  enrolledNotActive: #70c5e9,\n  notEnrolled: #fdb91d,\n  outOfCompliance: #cccccc,\n  appleNotinstalled: #fcbb15, \n\n  // Primary - Blue color\n  primary: (\n    base: $primary,\n    light: lighten($primary, 15%),\n    lightest: lighten($primary, 60%),\n    dark: darken($primary, 15%)\n  ),\n\n  // Secondary - Orange color\n  secondary: (\n    base: $secondary,\n    light: lighten($secondary, 15%),\n    lightest: lighten($secondary, 60%),\n    dark: darken($secondary, 15%)\n  ),\n\n  // default - Gray color\n  default: (\n    base: $default,\n    light: lighten($default, 5%), // #fff white\n    dark: darken($default, 12.8%), // #d2d2d2 ATT Light Gray\n    darker: darken($default, 18%) // #c4c4c4\n  ),\n\n  // Inverse - Black color\n  inverse: (\n    base: $inverse,\n    light: lighten($inverse, 11.25%), // #767676 Auxiliary Gray\n    lightest: lighten($inverse, 25%), // #999999\n    lighter: lighten($inverse, 23.4%), // #959595 ATT Gray\n    dark: darken($inverse, 15%), // #333 ATT Dark Gray (2015)\n    darker: darken($inverse, 25.2%), // #191919 Functional Digital Text Black\n    darkest: darken($inverse, 35%) // #000 \n  ),\n\n  // danger - Red color\n  danger: (\n    base: $danger,\n    light: lighten($danger, 15%),\n    dark: darken($danger, 15%)\n  ),\n\n  // success - Green color\n  success: (\n    base: $success,\n    light: lighten($success, 15%),\n    dark: darken($success, 15%)\n  )\n);\n","@import '../../../../lib/ng2-sapmp/src/assets/style/mixinfunction';\n\n.confirm-wrapper {\n  margin: 0 16.66%;\n  //font-family: 'ATTAleckSans-Regular' !important;\n\n  h1 {\n    margin: 30px 0;\n    //font-family: 'ATTAleckSans-Regular' !important;\n  }\n\n  .alert {\n    margin-bottom: 30px;\n    border-radius: 8px;\n  }\n  .alert div:first-child {\n    border-radius: 8px 0 0 8px;\n  }\n  @media only screen and (max-width: 700px) and (min-width: 390px){\n   .alert .close {\n    right: -6px;\n    top: -2px;\n  }}\n\n  .panel-header {\n    background-color: color(default, base);\n    border: 0;\n    margin: 30px 0 0;\n\n    .panel-message {\n      padding: 20px 10px 1px 30px;\n      //font-family: 'ATTAleckSans-Regular' !important;\n    }\n  }\n\n  .buttons-section {\n    \n    margin-top: 30px;\n    padding: 30px 0 60px;\n    //font-family: 'ATTAleckSans-Regular' !important;\n\n    .btn-cancel {\n      margin-right: 5px;\n    }\n  }\n\n  .btn-link {\n    padding-top: 10px;\n  }\n\n  @include respond-to(small) {\n    .btn-link {\n      padding-top: 0;\n    }\n\n    .btn {\n      padding: 0;\n      //font-family: 'ATTAleckSans-Regular' !important;\n    }\n\n    .btn-cancel {\n      margin: 20px 0 0;\n    }\n\n    .buttons-section {\n      padding: 30px 0;\n    }\n  }\n\n  app-customgrid {\n    div {\n      p {\n        display: none;\n      }\n    }\n  }\n\n  .home-link {\n    margin-left: -17px;\n    margin-top: -14px;\n  }\n\n  @include respond-to(small) {\n    margin: 0 15px;\n    margin-top: 70px;\n\n    .btn {\n      text-align: center;\n      width: 100%;\n      //font-family: 'ATTAleckSans-Regular' !important;\n    }\n  }\n\n}\n\n.confirm-wrappermdm {\n  margin: 0 16.66%;\n\n  h1 {\n    margin: 30px 0;\n  }\n\n  .alert {\n    margin-bottom: 30px;\n  }\n\n  .panel-header {\n    background-color: color(default, base);\n    border: 0;\n    margin: 30px 0 0;\n\n    .panel-message {\n      padding: 20px 10px 1px 30px;\n    }\n  }\n\n  .buttons-section {\n    \n    margin-top: 30px;\n    padding: 30px 0 60px;\n\n    .btn-cancel {\n      margin-right: 5px;\n    }\n  }\n\n  .btn-link {\n    padding-top: 10px;\n  }\n\n  @include respond-to(small) {\n    .btn-link {\n      padding-top: 0;\n    }\n\n    .btn {\n      padding: 0;\n    }\n\n    .btn-cancel {\n      margin: 20px 0 0;\n    }\n\n    .buttons-section {\n      padding: 30px 0;\n    }\n  }\n\n  app-customgrid {\n    div {\n      p {\n        display: none;\n      }\n    }\n  }\n\n  .home-link {\n    margin-left: -17px;\n    margin-top: -14px;\n  }\n\n  @include respond-to(small) {\n    margin: 0 15px;\n\n    .btn {\n      text-align: center;\n      width: 100%;\n    }\n  }\n\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
